import { yupResolver } from '@hookform/resolvers/yup'
import { useForm } from 'react-hook-form'
import { InferType } from 'yup'
import { verifyOrderFormSchema } from './verify-order-form.schema'
import { Order } from '../../../store/orders/orders.types'
import { useEffect } from 'react'

export type VerifyOrderFormValues = InferType<typeof verifyOrderFormSchema>

export const useVerifyOrderForm = (
  order: Order,
  defaultValuesOverride?: VerifyOrderFormValues
) => {
  const form = useForm<VerifyOrderFormValues>({
    resolver: yupResolver(verifyOrderFormSchema),
    defaultValues: defaultValuesOverride ?? verifyOrderFormSchema.cast(order),
  })

  const { watch, setValue } = form
  const pickupStart = watch('orderEvents.0.startTime')
  const deliveryStart = watch('orderEvents.1.startTime')

  useEffect(() => {
    if (pickupStart) {
      setValue('orderEvents.0.endTime', pickupStart, { shouldValidate: true })
    }
  }, [pickupStart, setValue])

  useEffect(() => {
    if (deliveryStart) {
      setValue('orderEvents.1.endTime', deliveryStart, { shouldValidate: true })
    }
  }, [deliveryStart, setValue])

  return form
}
